import { render, staticRenderFns } from "./Preamble.vue?vue&type=template&id=0b275c56"
import script from "./Preamble.vue?vue&type=script&lang=js"
export * from "./Preamble.vue?vue&type=script&lang=js"
import style0 from "./Preamble.vue?vue&type=style&index=0&id=0b275c56&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports